import { Buttons } from '../Buttons'
import { useTw } from '../../../../../../../../../utils/Styles'
import { ConversationQuery } from '../../../../Conversation.generated'

type ContentCardProps = {
  event: ConversationQuery['Conversation']['messages'][0]
}

function CardTitle({ title, href }: { title?: string; href?: string }) {
  const tw = useTw()

  if (title) {
    if (href) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noreferrer noopener"
          className={tw`text-foreground font-bold`}
        >
          {title}
        </a>
      )
    }

    return <h1 className={tw`text-gray-500 font-bold`}>{title}</h1>
  }

  return null
}

export function ContentCard({ event }: ContentCardProps) {
  const tw = useTw()
  return (
    <div className={tw`rounded shadow-md bg-white w-full px-4 pt-5 pb-8`}>
      {event.card.appTitle && (
        <header className={tw`flex items-center space-x-1.5`}>
          {event.card.appIcon && (
            <img
              alt="Card app icon"
              src={event.card.appIcon}
              className={tw`block h-4 w-4`}
            />
          )}
          <h2 className={tw`text-gray-900 font-bold`}>{event.card.appTitle}</h2>
        </header>
      )}
      {event.card.image && (
        <img
          alt="Image content"
          src={event.card.image}
          className={tw`w-full py-2`}
        />
      )}
      <CardTitle title={event.card.title} href={event.card.link} />
      {event.card.description && (
        <p className={tw`text-sm text-gray-500`}>{event.card.description}</p>
      )}
      <div className={tw`space-y-2 pt-4`}>
        <Buttons event={event} />
      </div>
    </div>
  )
}
